export default {"src":"/_next/static/media/close-dialog.5047c366.svg","height":46,"width":46};